export default {"src":"/_next/static/media/brighterai.4cb74d6d.svg","height":23,"width":125,"blurWidth":0,"blurHeight":0};